import isEmpty from 'lodash/isEmpty';

export type LabelsFieldOption = {
	id: string | null;
	name: string;
}[];

export const getLabelsFieldValue = (defaultValue: unknown): LabelsFieldOption | null => {
	if (typeof defaultValue === 'string') {
		return [{ id: null, name: defaultValue }];
	}
	const constructedLabels: LabelsFieldOption = [];
	if (Array.isArray(defaultValue)) {
		for (const value of defaultValue) {
			if (typeof value === 'string') constructedLabels.push({ name: value, id: null });
		}
		return isEmpty(constructedLabels) ? null : constructedLabels;
	}
	return null;
};
